import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "text-4xl text-darkgray-400" }
const _hoisted_3 = { class: "font-bold text-primary-700" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 right-0 w-4 h-4 bg-red-700 border-4 border-white rounded-full has-notif" }, null, -1)
const _hoisted_5 = { class: "mb-5 text-neutral-700" }
const _hoisted_6 = { class: "text-primary-500" }
const _hoisted_7 = { class: "border-b border-black/[0.04] pb-10 mb-10" }
const _hoisted_8 = { class: "pb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-xl font-bold" }, "Upcoming Appointments", -1)
const _hoisted_10 = { class: "flex flex-wrap items-end" }
const _hoisted_11 = { class: "w-full mb-8 lg:mb-0 lg:w-[336px]" }
const _hoisted_12 = {
  key: 0,
  class: "w-full lg:w-[calc(100%-336px)] lg:pl-6 relative"
}
const _hoisted_13 = {
  key: 0,
  class: "hidden mb-12 text-right lg:block"
}
const _hoisted_14 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6" }
const _hoisted_15 = {
  key: 1,
  class: "block mt-4 text-left lg:hidden"
}
const _hoisted_16 = {
  key: 2,
  class: "h-[300px]"
}

import PortalLayout from '@/layouts/PortalLayout.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import AppointmentImageCard from '@/components/cards/AppointmentImageCard.vue';
import AppointmentCard from '@/components/cards/AppointmentCard.vue';
import PageLoader from "@/components/PageLoader.vue";
import { BellIcon } from '@heroicons/vue/24/outline';

import patient from "@/classes/UserData";
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

const loader = ref(false)
const upcomingAppointments = ref([]);
const ongoingAppointment = ref([]);
const notifCount = ref(0);
const ongoingCount = ref(0);
const appointmentStatus = ref([]);

const patientData = computed(() => patient.getCurrentUser())

const redirectToAppointment = (appointment: object) => {
    if(appointment.booking_type == 'Soft') {
        window.location.assign(`/soft-booking-appointment/show/${appointment.id}`)
    } else {
        window.location.assign(`/appointment/show/${appointment.booking_id}`)
    }
}

const fetchData = () => {
    loader.value = true

    patient.getDashboard(patientData.value.patient_id)
        .then((result: any) => {
            loader.value = false
            upcomingAppointments.value = result.data.upcoming
            ongoingAppointment.value = result.data.ongoing

            notifCount.value = result.data.notifCount
            ongoingCount.value = ongoingAppointment.value.length

            appointmentStatus.value = result.data.appointmentStatus;
        })
        .catch((err) => {
            loader.value = false
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const checkReadStatus = (appointment) => {
    if(appointment.booking_type == 'Soft') {
        return appointmentStatus.value.find(x => x.booking_id == appointment.id).read_at == null;
    } else {
        return appointmentStatus.value.find(x => x.booking_id == appointment.booking_id ? appointment.booking_id : appointment.id).read_at == null;
    }
}

onMounted( () => fetchData())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, {
    notifCount: notifCount.value,
    defaultTitle: false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createTextVNode("Good morning, "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(patientData.value?.first_name) + "!", 1)
        ]),
        _createElementVNode("div", {
          class: "relative cursor-pointer",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/notifications')), ["prevent"]))
        }, [
          _createVNode(_unref(BellIcon), { class: "w-7 h-7" }),
          _hoisted_4
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode("You have "),
        _createElementVNode("strong", _hoisted_6, _toDisplayString(ongoingCount.value) + " " + _toDisplayString(ongoingCount.value == 1 ? 'Appointments ' : 'Appointment '), 1),
        _createTextVNode("scheduled today")
      ]),
      _createElementVNode("div", _hoisted_7, [
        (ongoingAppointment.value[0])
          ? (_openBlock(), _createBlock(AppointmentImageCard, {
              key: 0,
              "appointment-today": ongoingAppointment.value[0]
            }, null, 8, ["appointment-today"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(CalendarPicker, { appointments: upcomingAppointments.value }, null, 8, ["appointments"])
          ]),
          (upcomingAppointments.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (upcomingAppointments.value?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", {
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/appointment')), ["prevent"])),
                        class: "text-sm font-semibold cursor-pointer text-primary-500"
                      }, "View All")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingAppointments.value, (upcoming, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: key
                    }, [
                      _createVNode(AppointmentCard, {
                        onClick: ($event: any) => (redirectToAppointment(upcoming)),
                        item: upcoming,
                        badge: checkReadStatus(upcoming)
                      }, null, 8, ["onClick", "item", "badge"])
                    ]))
                  }), 128))
                ]),
                (upcomingAppointments.value?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("p", {
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push('/appointment')), ["prevent"])),
                        class: "text-sm font-semibold cursor-pointer text-primary-500"
                      }, "View All")
                    ]))
                  : _createCommentVNode("", true),
                (upcomingAppointments.value?.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No Upcoming Appointment "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notifCount"]))
}
}

})